import React, { Component } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {Modal, Button,Tabs,Tab,ButtonToolbar,OverlayTrigger,Tooltip} from 'react-bootstrap';
import { TextField  } from '@rmwc/textfield';
import Scrollbar from 'react-scrollbars-custom';
import {connect} from 'react-redux';
import { Select } from '@rmwc/select';
import ImageEditor from '@toast-ui/react-image-editor';
import {showImageEditor} from "../../action/extra_options/orderExtras.action.js"

const ImageEditorNew = () => {
  const dispatch = useDispatch();
  const imageEditor = React.createRef();
  const myTheme = {
  
  // Theme object to extends default dark theme.
};
const props = useSelector(state => state.reducer);
  const propsNew = useSelector(state => state.orderExtrasReducer);
  const ImgName = propsNew.BlobImageName;
const saveImageToDisk = (e)=>{
  const imageEditorInst = imageEditor.current.imageEditorInst;
    const data = imageEditorInst.toDataURL();
    if (data) {
      const mimeType = data.split(";")[0];
      const extension = data.split(";")[0].split("/")[1];
    }
    dispatch(showImageEditor(e,data,false,propsNew.BlobImageIndex));
}
  

  return (
    <Modal enforceFocus={false}  centered show={props.const_var.isShowEmageEditor} backdrop='static' onHide={(e) => dispatch(showImageEditor(e,ImgName,false,''))} keyboard={false} dialogClassName="image-beautify-modal react-modal" backdropClassName="ract-modal-pre-parent image-beautify-parent" >
      <button className="close" onClick={(e) => dispatch(showImageEditor(e,ImgName,false,''))}><span className="icon-close"></span></button>
      <Modal.Body>
        <a className="save-beautify-img"  onClick={(e)=>saveImageToDisk(e)}>
              <span className="icon icon-cart-2"></span>
              <span className="text">Save Image</span>
            </a>
        <ImageEditor usageStatistics={false}
            includeUI={{
              loadImage: {
                path: ImgName,
                name: 'SampleImage',
              },
              theme: myTheme,
              menu: ["crop", "flip", "rotate", "draw", "shape", "text", "filter"],
              initMenu: '',
              uiSize: {
                height: '700px',
              },
              menuBarPosition: 'bottom',
            }}
            cssMaxHeight={500}
            cssMaxWidth={700}
            selectionStyle={{
              cornerSize: 20,
              rotatingPointOffset: 70,
            }}
            usageStatistics={true}
            ref={imageEditor}
          />
        
      </Modal.Body>

    </Modal>
  );
}
export default (ImageEditorNew);